import { render } from "./StudentLogin.vue?vue&type=template&id=44401e4a&scoped=true"
import script from "./StudentLogin.vue?vue&type=script&lang=js"
export * from "./StudentLogin.vue?vue&type=script&lang=js"

import "./StudentLogin.vue?vue&type=style&index=0&id=44401e4a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44401e4a"]])

export default __exports__